import { render } from "./import-scans.vue?vue&type=template&id=50ee8710&scoped=true"
import script from "./import-scans.vue?vue&type=script&lang=js"
export * from "./import-scans.vue?vue&type=script&lang=js"

import "./import-scans.vue?vue&type=style&index=0&id=50ee8710&scoped=true&lang=css"

import exportComponent from "C:\\Users\\softw\\Documents\\Software\\Projects\\CodeRedLabs\\manila-customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ee8710"]])

export default __exports__